import { type Result } from '@carvana/merch-result';
import { getAxiosAuthHeader, httpWithAuth } from '~/clients';
import { GET_TRADE_INFO } from '~/constants/endpoints';
import type { Trade } from '~/contracts/common';

type TradeIn = Omit<Trade, 'effectiveDate'> & {
  effectiveDate: string;
};

const fetchTrades = (controller: AbortController) =>
  httpWithAuth.get<Result<TradeIn[]>>(GET_TRADE_INFO, {
    headers: getAxiosAuthHeader(),
    signal: controller.signal
  });

export default fetchTrades;
